
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-card/massachusetts",
      function () {
        return require("private-next-pages/medical-card/massachusetts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-card/massachusetts"])
      });
    }
  